module.exports = __webpack_public_path__ + "img/Group 97681.ca8bb85d.png";